import React, { useState, useEffect } from "react";
import {
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  TextField,
  Autocomplete,
  ListItemText,
  MenuItem,
  FormGroup,
  Checkbox,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
} from "@mui/material";

import { Box } from "@mui/system";
import { MoneyFormatv3 } from "../../../library/MoneyFormat";
import AddAccountModal from "../Modals/AddAccountModal";
import { grey } from "@mui/material/colors";
import {
  showErrorSnackbar,
  showWarningSnackbar,
} from "../../../components/snackBar/snakbar";
import { API, graphqlOperation } from "aws-amplify";
import { getRelatedPaymentDetails } from "../../../graphql";
import AddBankAccountModal from "../Modals/AddBankAccountModal";
import { AddBox } from "@mui/icons-material";
import LabelIcon from "./LabelIcon";
import { MoneyInputv3 } from "../../../components/formElements/moneyFormatInput";
import PaymentWarningModal from "../Modals/PaymentWarningModal";
import { useThemes } from "../../../components/Theme/theme";
import { useListAccountMasterv2Query } from "../../../redux/apis/accountMaster.api";

import { useSelector } from "react-redux";
import { useStateList } from "./HandleInvoiceStateProvider";
import moment from "moment";
import UseLedgerAccount from "./UseLedgerAccount";
import { makeStyles } from "@mui/styles";
import { MoneyTextField } from "../../../components";
const useStyles = makeStyles({
  table: {
    "& .MuiTableCell-root": {
      border: "none",
    },
  },
});
function PosPaymentDetails({ Type }) {
  const { theme } = useThemes();
  const classes = useStyles();

  const {
    setInitialState,
    data,
    setData,

    accNames,
    viewMode,


    invoiceEntry,

    totNetAmt,

    netAmountToPay,

    companyData,
    setPaymentTransID,
    lastUsedCashAcc,
    lastUsedBankAcc,
    setBackdropOpen,
    setCurrentVoucherNo,

    partyType,
  } = useStateList();
  const [openAccountModal, setAddAccountModal] = useState(false);
  const [openBankAccountModal, setOpenBankAccountModal] = useState(false);
  const [newTransVouch, setNewTransVouch] = useState("");
  const [newSerilNo, setNewSerialNo] = useState({ lable: "", value: "" });
  const [openPaymentWarningModal, setOpenPaymentWarningModal] = useState(false);
  const [currentPaymentAccObj, setCurrentPaymentAccObj] = useState({
    label: "",
    value: "",
  });
  const [cashPaymentObj, setCashPaymentObj] = useState({
    label: "",
    value: "",
  });
  const [bankPaymentObj, setBankPaymentObj] = useState({
    label: "",
    value: "",
  });
  let getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );
  let companyType = getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;
  const { cashAccount, bankAccount } = UseLedgerAccount(Type);
  const handleCashPaymentChange = (e) => {
    const isChecked = e.target.checked;
    setData((prev) => {
      if (!isChecked && !prev?.bankPayment) {
        showWarningSnackbar("At least one payment method must be selected.");
        return prev;
      }
      if (Number(data?.bankReceivedAmount) === Number(netAmountToPay)) {
        showWarningSnackbar("The payment has already been completed via bank.");
        return prev;
      }
  
      return {
        ...prev,
        cashPayment: isChecked,
        receivedAccount: isChecked ? lastUsedCashAcc : { label: "", value: "" },
        receivedAmount: isChecked ? prev.receivedAmount : 0,
        errorStatus: {
          ...prev.errorStatus,
          receivedAccount: false,
        },
        errorFields: {
          ...prev.errorFields,
          receivedAmount: "",
        },
      };
    });
  };
  function roundTo2(value) {
    return Math.round(Number(value) * 100) / 100;
  }
  
  const handleReceivedAccountChange = (e, newValue) => {
    if (newValue?.value !== "Add Accounts") {
      setData((prev) => ({
        ...prev,
        receivedAccount: newValue,
      }));
    }
  };
  const handleAddCashAccountClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (!viewMode) {
      setAddAccountModal(true);
    }
  };
  function handleReceivedAmountChange(val) {
    // let value = e.replace(/,/g, "");
    let value=Number(val);
    // if (!/^-?\d*(?:\.\d*)?$/.test(value)) return;
    // if (/^-?\d*\.?\d{0,2}$/.test(value) === false) return;
    // if (!/^\d*(?:\.\d*)?$/.test(value)) return;

    const enteredAmount = roundTo2(value);
    const remainingAmount = roundTo2(Number(netAmountToPay) - Number(data?.bankReceivedAmount));
    
    if (enteredAmount > remainingAmount) {
      showWarningSnackbar("The entered amount exceeds the total payable amount.");
      return;
    }
  
    if (data.cashPayment) {
      if (value === "") {
        setData((prev) => ({
          ...prev,
          receivedAmount: value,
          errorStatus: {
            ...prev.errorStatus,
            receivedAmount: true,
          },
          errorFields: {
            ...prev.errorFields,
            receivedAmount: "Cash Received Amount is required",
          },
        }));
      } else if (value > Number(netAmountToPay)) {
        setData((prev) => ({
          ...prev,
          receivedAmount: value,
          errorStatus: {
            ...prev.errorStatus,
            receivedAmount: true,
          },
          errorFields: {
            ...prev.errorFields,
            receivedAmount: "Amount should be less than Grand Total.",
          },
        }));
      } else if (Number(value) === Number(netAmountToPay)) {
        setData((prev) => ({
          ...prev,
          receivedAmount: value,
          bankPayment: false,
          errorStatus: {
            ...prev.errorStatus,
            receivedAmount: false,
          },
          errorFields: {
            ...prev.errorFields,
            receivedAmount: "",
          },
        }));
      } else {
        setData((prev) => ({
          ...prev,
          receivedAmount: value,
          errorStatus: {
            ...prev.errorStatus,
            receivedAmount: false,
          },
          errorFields: {
            ...prev.errorFields,
            receivedAmount: "",
          },
        }));
      }
    } else {
      setData((prev) => ({
        ...prev,
        receivedAmount: value,
        errorStatus: {
          ...prev.errorStatus,
          receivedAmount: false,
        },
        errorFields: {
          ...prev.errorFields,
          receivedAmount: "",
        },
      }));
    }
  }
  function handleBankPaymentChange(e) {
    const isChecked = e.target.checked;
    setData((prev) => {
      if (!isChecked && !prev?.cashPayment) {
        showWarningSnackbar("At least one payment method must be selected.");
        return prev; // Prevent unselecting both
      }
      if (Number(data?.receivedAmount) === Number(netAmountToPay)) {
        showWarningSnackbar("The payment has already been completed in cash.");
        return prev; // Prevent unselecting both
      }
  
      return {
        ...prev,
        bankPayment: isChecked,
        bankReceivedAccount: isChecked ? lastUsedBankAcc : { label: "", value: "" },
        bankReceivedAmount: isChecked ? prev.bankReceivedAmount : 0,
        errorStatus: {
          ...prev.errorStatus,
          bankReceivedAmount: false,
        },
        errorFields: {
          ...prev.errorFields,
          bankReceivedAmount: "",
        },
      };
    });
  }
  function handleBankReceivedAccountChange(e, newValue) {
    if (newValue?.value !== "Add Accounts") {
      setData((prev) => ({
        ...prev,
        bankReceivedAccount: newValue,
      }));
    }
  }
  
  function handleBankAddAccountsClick(event) {
    event.stopPropagation();
    event.preventDefault();
    if (viewMode !== true) {
      setOpenBankAccountModal(true);
    }
  }
  function handleBankReceivedAmountChange(val) {
    // let value = e.replace(/,/g, "");
    let value=Number(val);
    
    // if (!/^-?\d*(?:\.\d*)?$/.test(value)) return;
    // if (/^-?\d*\.?\d{0,2}$/.test(value) === false) return;
    // if (!/^\d*(?:\.\d*)?$/.test(value)) return;
  
    const enteredAmount = roundTo2(value);
    const remainingAmount = roundTo2(Number(netAmountToPay) - Number(data?.receivedAmount));
    
    if (enteredAmount > remainingAmount) {
      showWarningSnackbar("The entered amount exceeds the total payable amount.");
      return;
    }
    
  
    if (data.bankPayment) {
      if (value === "") {
        setData((prev) => ({
          ...prev,
          bankReceivedAmount: value,
          errorStatus: {
            ...prev.errorStatus,
            bankReceivedAmount: true,
          },
          errorFields: {
            ...prev.errorFields,
            bankReceivedAmount: "Bank Received Amount is required",
          },
        }));
      } else if (value > Number(netAmountToPay)) {
        setData((prev) => ({
          ...prev,
          bankReceivedAmount: value,
          errorStatus: {
            ...prev.errorStatus,
            bankReceivedAmount: true,
          },
          errorFields: {
            ...prev.errorFields,
            bankReceivedAmount: "Amount should be less than Grand Total.",
          },
        }));
      } else if (Number(value) === Number(netAmountToPay)) {
        setData((prev) => ({
          ...prev,
          bankReceivedAmount: value,
          cashPayment: false,
          errorStatus: {
            ...prev.errorStatus,
            bankReceivedAmount: false,
          },
          errorFields: {
            ...prev.errorFields,
            bankReceivedAmount: "",
          },
        }));
      } else {
        setData((prev) => ({
          ...prev,
          bankReceivedAmount: value,
          errorStatus: {
            ...prev.errorStatus,
            bankReceivedAmount: false,
          },
          errorFields: {
            ...prev.errorFields,
            bankReceivedAmount: "",
          },
        }));
      }
    } else {
      setData((prev) => ({
        ...prev,
        bankReceivedAmount: value,
        errorStatus: {
          ...prev.errorStatus,
          bankReceivedAmount: false,
        },
        errorFields: {
          ...prev.errorFields,
          bankReceivedAmount: "",
        },
      }));
    }
  }
  
  async function dispalyPaymentDetails(invoiceEntry) {
    try {
      if (invoiceEntry.length !== 0) {
        let paidAmt = 0;
        let bankPaidAmt = 0;
        let invDate = "";
        let paymentMethod = "";
        if (Type === "Sales" || Type === "Pos") {
          paidAmt = invoiceEntry.receivedamount;
          paymentMethod = invoiceEntry.paymenttype;
          invDate = invoiceEntry?.invoicedate;
          bankPaidAmt = invoiceEntry?.bankamount;
        }
        if (Type === "Purchase") {
          paidAmt = invoiceEntry.paidamount;
          paymentMethod = invoiceEntry.paymenttypecd;
          invDate = invoiceEntry?.entrydate;
        }
        if (Type === "DebitNote" || Type === "CreditNote") {
          paidAmt = invoiceEntry?.relatedcrdrnotedetails?.[0]?.partamount;
          paymentMethod = invoiceEntry.paymenttype;
          invDate = invoiceEntry?.crdrnotedate;
        }
        let accountObj = { label: "", value: "" };
        let bankAccountObj = { label: "", value: "" };
        accNames.map((ele) => {
          if (ele.value === invoiceEntry.paymentaccountid) {
            accountObj = { label: ele.label, value: ele.value };
          }
          if (ele.value === invoiceEntry?.bankaccountid) {
            bankAccountObj = { label: ele.label, value: ele.value };
          }
        });
        if (Type === "DebitNote" || Type === "CreditNote") {
          accNames.map((ele) => {
            if (
              ele.value == invoiceEntry?.relatedcrdrnotedetails?.[0]?.accountid
            ) {
              accountObj = { label: ele.label, value: ele.value };
            }
          });
        }
        let temp = JSON.parse(
          JSON.stringify({
            paymentType: paymentMethod,
            receivedAmount: paidAmt,
            receivedAccount: accountObj,
            bankReceivedAmount: bankPaidAmt,
            bankPayment:
              bankAccountObj?.value === "" || bankAccountObj?.value == 0
                ? false
                : true,
            cashPayment:
              accountObj?.value === "" || accountObj?.value == 0 ? false : true,
            bankReceivedAccount: bankAccountObj,
            creditPeriod: invoiceEntry.creditduration,
          })
        );

        setCurrentPaymentAccObj(accountObj);
        // let Promises = [getPaymentVoucherDetails(invoiceEntry, accountObj)];
        // await Promise.all(Promises);
        setData((prev) => ({
          ...prev,
          paymentType: paymentMethod,
          receivedAmount: paidAmt,
          receivedAccount: accountObj,
          bankReceivedAmount: bankPaidAmt,
          bankPayment:
            bankAccountObj?.value === "" || bankAccountObj?.value == 0
              ? false
              : true,
          cashPayment:
            accountObj?.value === "" || accountObj?.value == 0 ? false : true,
          bankReceivedAccount: bankAccountObj,
          creditPeriod: invoiceEntry.creditduration,
        }));
        if (setInitialState)
          setInitialState((prev) => ({
            ...prev,
            ...temp,
          }));

        let dueDate = "";
        if (paymentMethod === "Credit") {
          let datt = moment(new Date(invDate * 1000)).format("DD MMM YYYY");
          dueDate = moment(
            moment(datt).add(invoiceEntry?.creditduration, "days")._d
          ).format("DD MMM YYYY");
          setData((prev) => ({
            ...prev,
            dueDate: dueDate,
          }));
          if (setInitialState)
            setInitialState((prev) => ({
              ...prev,
              dueDate: dueDate,
            }));
        }
      }
    } catch (e) {
      setBackdropOpen(false);
      console.log("error", e);
    }
  }

  function getPaymentVoucherDetails(invoiceEntry, accountObj) {
    if (Object.keys(invoiceEntry).length !== 0) {
      let invID = 0;
      let invType = "";
      if (Type === "Sales") {
        invID = invoiceEntry.invoiceid;
        invType = "SalesInvoice";
      }
      if (Type === "Pos") {
        invID = invoiceEntry.invoiceid;
        invType = "PosInvoice";
      }
      if (Type === "Purchase") {
        invID = invoiceEntry.purchaseid;
        invType = "PurchaseInvoice";
      }
      if (Type === "DebitNote") {
        invID = invoiceEntry.crdrnoteid;
        invType = "DebitNote";
      }
      if (Type === "CreditNote") {
        invID = invoiceEntry.crdrnoteid;
        invType = "CreditNote";
      }
      // listCurrentTransaction(invID);
      getCurrentTransactionVouchers(invType, invID, accountObj);
    }
  }

  async function getCurrentTransactionVouchers(invType, invID, accountObj) {
    try {
      const res = await API.graphql(
        graphqlOperation(getRelatedPaymentDetails, {
          invoicetype: invType,
          id: invID,
        })
      );

      let currentVouchNo = "";
      let currentSerialNo = { label: "", value: "" };
      let transactionType = "";
      let transID = "";
      if (res?.data?.getRelatedPaymentDetails?.length > 0) {
        currentVouchNo =
          res?.data?.getRelatedPaymentDetails?.[0]?.paymentvouchernumber;
        currentSerialNo = {
          label: res?.data?.getRelatedPaymentDetails?.[0]?.serialnumber,
          value: res?.data?.getRelatedPaymentDetails?.[0]?.serialnumber,
        };

        transactionType =
          res?.data?.getRelatedPaymentDetails?.[0]?.transactiontypecd;
        transID = Number(
          res?.data?.getRelatedPaymentDetails?.[0].paymenttransactionid
        );

        if (
          transactionType === "CashReceipt" ||
          transactionType === "CashPayment"
        ) {
          setCashPaymentObj(accountObj);
        }
        if (
          transactionType === "BankReceipt" ||
          transactionType === "BankPayment"
        ) {
          setBankPaymentObj(accountObj);
        }
      } else {
        currentVouchNo = newTransVouch;
        currentSerialNo = newSerilNo;
        setData((prev) => ({
          ...prev,
          receivedAmount: 0,
          paymentType: "Credit",
        }));
        setInitialState((prev) => ({
          ...prev,
          receivedAmount: 0,
          paymentType: "Credit",
        }));
      }

      setPaymentTransID(transID);
      setCurrentVoucherNo(currentVouchNo);

      setData((prev) => ({
        ...prev,
        transactionVoucher: currentVouchNo,
        transactionSeries: currentSerialNo,
      }));
      if (setInitialState)
        setInitialState((prev) => ({
          ...prev,
          transactionVoucher: currentVouchNo,
          transactionSeries: currentSerialNo,
        }));
    } catch (error) {
      setBackdropOpen(false);
      console.log("error", error);
    }
  }
  useEffect(() => {
    dispalyPaymentDetails(invoiceEntry);
  }, [invoiceEntry]);

  return (
    <Box sx={{borderTop:{xs:'solid 1px gray', lg:'none'},marginTop:{xs:'10px',lg:'0px'}}}>

      <TableContainer>

      <Table
        className={classes.table}
        sx={{
          ".MuiTableCell-root": {
            backgroundColor: "transparent !important",
            padding: "1px 10px",
            fontSize: "13px",
          },
        }}
      >
        <TableBody>
          {/* Cash Payment Row */}
          <TableRow sx={{height:"90px"}}>
            <TableCell sx={{ width: "5%",border:"none !important"}}>
              <Checkbox
                size="small"
                sx={{ verticalAlign: "middle" }}
                id="cashPayment"
                name="cashPayment"
                checked={!!data?.cashPayment}
                disabled={totNetAmt === 0 || viewMode === true ? true : false}
                onChange={handleCashPaymentChange}
              />
            </TableCell>
            <TableCell sx={{ fontSize: "13px", fontWeight: 600,border:"none !important" }}>
              {Type === "Pos" ? "Cash Payment" : "Cash/Part Payment"}
            </TableCell>
            <TableCell sx={{ minWidth: 200 ,border:"none !important"}}>
              {data?.cashPayment && (
                <>
                  <Autocomplete
                    id="receivedAccount"
                    name="receivedAccount"
                    options={[
                      "Add Accounts",
                      ...cashAccount.sort((a, b) =>
                        a.label.localeCompare(b.label)
                      ),
                    ]}
                    disabled={data.cashPayment !== true || viewMode === true || totNetAmt===0}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                    disableClearable
                    value={data?.receivedAccount}
                    onChange={handleReceivedAccountChange}
                    size="small"
                    renderOption={(props, option) => (
                      <>
                        {option === "Add Accounts" ? (
                          <MenuItem
                            value={"addAccount"}
                            onClick={handleAddCashAccountClick}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              position: "sticky",
                              // bottom: "-7.5px",
                              top: "0px",
                              zIndex: 1,
                              backgroundColor: grey[50],
                              "&:hover": {
                                backgroundColor: grey[200],
                              },
                            }}
                          >
                            <AddBox
                              fontSize="small"
                              sx={{
                                marginRight: "5px",
                                color: "primary.main",
                              }}
                            />
                            <ListItemText
                              sx={{ color: "primary.main" }}
                              primary={"Add Accounts"}
                            />
                          </MenuItem>
                        ) : (
                          <MenuItem
                            {...props}
                            key={option.value}
                            value={option.value}
                          >
                            <ListItemText primary={option.label} />
                          </MenuItem>
                        )}
                      </>
                    )}
                    renderInput={(params) => (
                      <TextField
                        required
                        error={data.errorStatus.receivedAccount}
                        label="Cash Received To Account (Dr)"
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <LabelIcon
                              value={data.receivedAccount.value}
                              type="Accounts"
                              params={params.InputProps.endAdornment}
                              editMode={false}
                            />
                          ),
                        }}
                      />
                    )}
                  />
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "danger.main",
                      position: "absolute",
                    }}
                  >
                    {data?.errorFields.receivedAccount}
                  </Typography>
                </>
              )}
            </TableCell>
            <TableCell sx={{ minWidth: 200,border:"none !important" }}>
              {data?.cashPayment && (
                <>
                  <MoneyTextField
                    error={data.errorStatus.receivedAmount}
                    label="Cash Received Amount"
                    id="receivedAmount"
                    name="receivedAmount"
                    page="Invoice"
                    type="text"
                    fullWidth
                    currencyType={data.currency.sign}
                    disabled={viewMode === true || totNetAmt === 0}
                    value={data?.receivedAmount?Number(data?.receivedAmount):null}
                    min={0}
                    max={Number((Number(netAmountToPay) - Number(data?.bankReceivedAmount)).toFixed(2))}
                    maxErrorMessage="The entered amount exceeds the total payable amount."
                    required
                    onChange={(val)=>handleReceivedAmountChange(val)}
                    size="small"
                  />
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "danger.main",
                      position: "absolute",
                    }}
                  >
                    {data?.errorFields.receivedAmount}
                  </Typography>
                </>
              )}
            </TableCell>
          </TableRow>

          {/* Bank Payment Row */}
          <TableRow>
            <TableCell sx={{border:"none !important"}}>
              <Checkbox
                size="small"
                sx={{ verticalAlign: "middle" }}
                id="bankPayment"
                name="bankPayment"
                disabled={totNetAmt === 0 || viewMode === true ? true : false}
                checked={!!data?.bankPayment}
                onChange={handleBankPaymentChange}
              />
            </TableCell>
            <TableCell sx={{ fontSize: "13px", fontWeight: 600 ,border:"none !important"}}>
              Bank/UPI/Card
            </TableCell>
            <TableCell sx={{ minWidth: 200 ,border:"none !important"}}>
              {data?.bankPayment && (
                <>
                  <Autocomplete
                    id="bankReceivedAccount"
                    name="bankReceivedAccount"
                    options={[
                      "Add Accounts",
                      ...bankAccount.sort((a, b) =>
                        a.label.localeCompare(b.label)
                      ),
                    ]}
                    disabled={
                      data.bankPayment !== true ||
                      viewMode === true ||
                      totNetAmt === 0
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                    disableClearable
                    value={data?.bankReceivedAccount}
                    onChange={handleBankReceivedAccountChange}
                    size="small"
                    renderOption={(props, option) => (
                      <>
                        {option === "Add Accounts" ? (
                          <MenuItem
                            value={"addAccount"}
                            onClick={handleBankAddAccountsClick}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              position: "sticky",
                              // bottom: "-7.5px",
                              top: "0px",
                              zIndex: 1,
                              backgroundColor: grey[50],
                              "&:hover": {
                                backgroundColor: grey[200],
                              },
                            }}
                          >
                            <AddBox
                              fontSize="small"
                              sx={{
                                marginRight: "5px",
                                color: "primary.main",
                              }}
                            />
                            <ListItemText
                              sx={{ color: "primary.main" }}
                              primary={"Add Accounts"}
                            />
                          </MenuItem>
                        ) : (
                          <MenuItem
                            {...props}
                            key={option.value}
                            value={option.value}
                          >
                            <ListItemText primary={option.label} />
                          </MenuItem>
                        )}
                      </>
                    )}
                    renderInput={(params) => (
                      <TextField
                        required
                        error={data.errorStatus.bankReceivedAccount}
                        label="Bank Received To Account (Dr)"
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <LabelIcon
                              value={data.bankReceivedAccount.value}
                              type="Accounts"
                              params={params.InputProps.endAdornment}
                              editMode={false}
                            />
                          ),
                        }}
                      />
                    )}
                  />
                  <Typography
                    sx={{ fontSize: "11px", color: "danger.main", mt: 1 }}
                  >
                    {data?.errorFields.bankReceivedAccount}
                  </Typography>
                </>
              )}
            </TableCell>
            <TableCell sx={{ minWidth: 200,border:"none !important"}}>
              {data?.bankPayment && (
                <>
                  <MoneyTextField
                    error={data.errorStatus.bankReceivedAmount}
                    label="Bank Received Amount"
                    id="bankReceivedAmount"
                    name="bankReceivedAmount"
                    page="Invoice"
                    type="text"
                    fullWidth
                    currencyType={data.currency.sign}
                    disabled={viewMode === true || totNetAmt === 0}
                    required
                    onChange={(val)=>handleBankReceivedAmountChange(val)}
                    value={data?.bankReceivedAmount?Number(data?.bankReceivedAmount):null}
                    min={0}
                    max={Number((Number(netAmountToPay) - Number(data?.receivedAmount)).toFixed(2))}
                    maxErrorMessage="The entered amount exceeds the total payable amount."
                    size="small"
                  />
                  <Typography sx={{ fontSize: "11px", color: "danger.main" }}>
                    {data?.errorFields.bankReceivedAmount}
                  </Typography>
                </>
              )}
            </TableCell>
          </TableRow>
          <TableRow sx={{ height: "5px" }}>
  <TableCell colSpan={4} sx={{ verticalAlign: "middle",border:"none !important" }}>
    {Number(netAmountToPay) -
      (Number(data?.receivedAmount) + Number(data?.bankReceivedAmount)) >
      0 && (
      <span
        style={{
          display: "flex",
          justifyContent: "flex-end",
          fontWeight: 600,
          color: "red",
          fontSize: "12px",
        }}
      >
        Balance amount to pay: {data.currency.sign}{" "}
        {MoneyFormatv3(
          (
            Number(netAmountToPay) -
            (Number(data?.receivedAmount) + Number(data?.bankReceivedAmount))
          ).toFixed(2),
          "en-IN"
        )}
      </span>
    )}
  </TableCell>
</TableRow>

        </TableBody>
      </Table>

      </TableContainer>

      {openAccountModal === true && (
        <AddAccountModal
          open={openAccountModal}
          setOpen={setAddAccountModal}
          setData={setData}
          data={data}
          accountType={data.paymentType}
          showErrorSnackbar={showErrorSnackbar}
          Type={Type}
          companyData={companyData}
        />
      )}
      {openBankAccountModal === true && (
        <AddBankAccountModal
          open={openBankAccountModal}
          setOpen={setOpenBankAccountModal}
          showErrorSnackbar={showErrorSnackbar}
          setData={setData}
          data={data}
          companyData={companyData}
          accountType={"receivedAccount"}
        />
      )}
      <PaymentWarningModal
        open={openPaymentWarningModal}
        setOpen={setOpenPaymentWarningModal}
        data={data}
        setData={setData}
        Type={Type}
      />
    </Box>
  );
}

export default PosPaymentDetails;
